export default "/images/32d585ef203246d9aab839f9f2f68d77.png";